<template>
  <div class="offer-container offer-table2 asset-container">
    <LandingBarFSP active="portfolio" />
    <v-dialog v-model="vError" persistent max-width="700">
      <v-card>
        <v-card-title class="text-h5"> Error </v-card-title>
        <v-card-text>There was an error with your transaction:</v-card-text>
        <v-card-text
          ><code>{{ vMessage }}</code></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="vError = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="offer-inner-container">
      <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
      <div class="table-top-flex">
        <h3 class="table-headline">Devices</h3>
        <v-text-field
          v-model="search"
          outlined
          label="Search company code, table, or address"
          class="search-field"
          hide-details
          background-color="#fff"
          :prepend-inner-icon="icons.mdiMagnify"
        >
          <template v-slot:append class="append-button">
            <v-btn depressed tile color="#58c26d" class="search-button" large>
              Search
            </v-btn>
          </template></v-text-field
        >
        <div class="offer-button-wrapper">
          <v-btn
            outline
            depressed
            class="filter-button"
            large
            v-on:click="changeFilter"
          >
            Filter
          </v-btn>
          <v-dialog v-model="dialog" width="740" class="modal">
            <template v-slot:activator="{ on, attrs }">
              <div class="offer-button-wrapper">
                <v-btn
                  depressed
                  tile
                  color="#58c26d"
                  class="search-button"
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>{{ icons.mdiPlus }}</v-icon
                  >Add device
                </v-btn>
              </div>
            </template>

            <v-card class="add-dialog-window">
              <div class="modal-wrapper">
                <div class="cancel-button-wrapper">
                  <div class="cancel-button-text" @click="dialog = false">
                    Cancel
                  </div>
                </div>

                <h1 class="modal-header">Add device</h1>

                <div class="modal-subheader">
                  Please fill out the form below
                </div>

                <div class="form-group">
                  <div class="form-flex">
                    <div class="column2">
                      <v-text-field
                        outlined
                        color="#58c26d"
                        validate-on-blur
                        dense
                        :rules="[rules.required]"
                        label="Name"
                        v-model="device.deviceName"
                      />
                      <!-- <div
                      v-if="errors.has('city')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      City Name is required!
                    </div> -->
                    </div>
                    <div class="column2">
                      <v-text-field
                        color="#58c26d"
                        outlined
                        validate-on-blur
                        dense
                        :rules="[rules.required]"
                        label="ID"
                        v-model="device.deviceId"
                      />
                      <!-- <div
                      v-if="errors.has('postcode')"
                      class="alert alert-danger"
                      role="alert"
                    >
                      Postcode is required!
                    </div> -->
                    </div>
                  </div>
                  <div class="form-flex">
                    <v-checkbox
                      v-model="device.enableTrigger"
                      label="Trigger delivery"
                    ></v-checkbox>
                  </div>
                </div>
              </div>
              <!-- <form enctype="multipart/form-data" class="upload-wrapper">
                <div class="upload">Upload offers from Excel file</div>
                <div class="upload-row">
                  <input
                    type="file"
                    name="file"
                    class="file-button"
                    :disabled="loading"
                  />
                  <v-btn
                    depressed
                    tile
                    color="#58c26d"
                    class="modal-button"
                    :disabled="loading"
                    small
                    v-on:click="importRequests"
                  >
                    Import
                  </v-btn>
                </div>
              </form> -->

              <div class="modal-button-wrapper">
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  depressed
                  tile
                  color="#58c26d"
                  class="modal-button"
                  large
                  v-on:click="saveDevice"
                >
                  Save device
                </v-btn>
              </div>
              <div class="loading-wrapper">
                <div class="loader-text" v-if="loading">Loading...</div>
              </div>
            </v-card>
          </v-dialog>

          <v-dialog v-model="edit" width="740" class="modal">
            <v-card class="add-dialog-window">
              <div class="modal-wrapper">
                <div class="cancel-button-wrapper">
                  <div class="cancel-button-text" @click="cancelEdit">
                    Cancel
                  </div>
                </div>
                <h1 class="modal-header">
                  Add asset for {{ device.deviceName }}
                </h1>
                <div class="modal-subheader">
                  Please fill out the form below
                </div>
                <div class="form-group">
                  <div class="form-flex">
                    <v-select
                      v-model="dAsset"
                      class="bottom-margin2"
                      label="Asset"
                      color="#58c26d"
                      hide-details
                      :rules="[rules.required]"
                      validate-on-blur
                      :items="assets"
                      item-text="assetName"
                      item-value="id"
                      dense
                      outlined
                    ></v-select>
                  </div>
                  <div class="form-flex">
                    <v-checkbox
                      v-model="device.enableTrigger"
                      label="Trigger delivery"
                    ></v-checkbox>
                  </div>
                </div>
              </div>
              <div class="modal-button-wrapper">
                <v-btn
                  :loading="loading"
                  :disabled="loading || !dAsset"
                  depressed
                  tile
                  color="#58c26d"
                  class="modal-button"
                  large
                  v-on:click="updateDevice"
                >
                  Save device
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <v-scale-transition>
        <div class="asset-filter-wrapper green-border" v-show="filter">
          <div class="chips-main">
            <v-select
              class="filter-input"
              :items="countries"
              label="Country"
              hide-details
              color="#58c26d"
              dense
              outlined
              :value="value"
              v-on:change="changeCountry"
            ></v-select>
            <div class="chips-wrapper">
              <v-chip
                class="ma-2"
                close
                color="green"
                outlined
                :key="country"
                :close-icon="icons.mdiCloseCircle"
                v-for="country in filterCountries"
                @click:close="() => closeCountry(country)"
              >
                {{ country }}
              </v-chip>
            </div>
          </div>
          <div class="chips-main">
            <v-select
              class="filter-input filter-input-middle"
              :items="postcodes"
              label="Postal code"
              hide-details
              color="#58c26d"
              dense
              outlined
              v-on:change="changePostal"
            ></v-select>
            <div class="chips-wrapper">
              <v-chip
                class="ma-2"
                close
                color="green"
                outlined
                :key="code"
                :close-icon="icons.mdiCloseCircle"
                v-for="code in filterPostalCodes"
                @click:close="() => closePostal(code)"
              >
                {{ code }}
              </v-chip>
            </div>
          </div>
          <div class="chips-main">
            <v-select
              class="filter-input"
              :items="cities"
              label="City"
              hide-details
              color="#58c26d"
              dense
              outlined
              v-on:change="changeCity"
            ></v-select>
            <div class="chips-wrapper">
              <v-chip
                class="ma-2"
                close
                color="green"
                outlined
                :key="city"
                :close-icon="icons.mdiCloseCircle"
                v-for="city in filterCities"
                @click:close="() => closeCity(city)"
              >
                {{ city }}
              </v-chip>
            </div>
          </div>
        </div>
      </v-scale-transition>

      <!-- <div class="offer-table">
        <vue-good-table
          :columns="columns"
          :rows="assets"
          :search-options="{ enabled: true }"
        >
          <div slot="selected-row-actions">
            <button>Action 1</button>
          </div>
        </vue-good-table>
      </div> -->
      <v-data-table
        :header-props="{ sortIcon: icons.mdiArrowUpBold }"
        :headers="headers"
        :items="getDevices"
        :search="search"
      >
        <template v-slot:item.id="{ item }">
          <v-btn
            class="edit-button"
            plain
            color="#58c26d"
            v-on:click="() => getAsset(item.id)"
            >Edit</v-btn
          >
        </template></v-data-table
      >
    </div>
  </div>
</template>

<script>
import AssetDataService from "../services/AssetDataService";
import CountryDataService from "../services/CountryDataService";

import LandingBarFSP from "../components/Common/LandingBarFSP";

import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";

import { mdiMagnify, mdiPlus, mdiArrowUpBold, mdiCloseCircle } from "@mdi/js";

export default {
  name: "assets-list",
  components: { LandingBarFSP, VueGoodTable },
  data() {
    return {
      dialog: false,
      edit: false,
      loading: false,
      vError: false,
      VMessage: "",
      locations: [],
      countries: [],
      dAsset: null,
      rules: {
        required: (value) => !!value || "Required",
        integer: (v) => {
          if (!v.trim()) return true;
          if (Number.isInteger(Number(v))) return true;
          return "Number has to be a whole number";
        },
      },
      icons: {
        mdiMagnify,
        mdiPlus,
        mdiArrowUpBold,
        mdiCloseCircle,
      },
      currentAsset: {
        id: null,
        companyCode: this.$store.state.auth.user.companyCode,
        assetCode: "",
        assetType: "",
        assetName: "",
        assetCapacity: "",
        assetAddress: "",
        assetCity: "",
        assetPostCode: "",
        assetCountry: this.$store.state.auth.user.countryCode,
        assetLong: "",
        assetLat: "",
      },
      asset: {
        id: null,
        companyCode: this.$store.state.auth.user.companyCode,
        assetCode: "",
        assetType: "",
        assetName: "",
        assetCapacity: "",
        assetAddress: "",
        assetCity: "",
        assetPostCode: "",
        assetCountry: this.$store.state.auth.user.countryCode,
        assetLong: "",
        assetLat: "",
      },
      types: [
        "Solar",
        "Wind",
        "EV",
        "Hydro",
        "Battery storage",
        "Consumer",
        "Prosumer",
      ],
      search: "",
      value: " ",
      filter: false,
      assets: [],
      devices: [],
      cities: [],
      postcodes: [],
      countries: [],
      address: false,
      filterCountries: [],
      filterCities: [],
      filterPostalCodes: [],
      submitted: false,
      currentIndex: -1,
      compapyCode: "",
      device: {enableTrigger: true},
      countries: ["Bulgaria"],
      headers: [
        {
          text: "Name",
          value: "deviceName",
        },
        {
          text: "ID",
          value: "deviceId",
        },
        {
          text: "Asset",
          value: "asset.assetName",
        },
        { text: "", value: "id", sortable: false },
      ],
      columns: [],
      bread: [
        {
          text: "Portfolio management",
          disabled: false,
          // href: "/dashboardFSP",
        },
        {
          text: "Devices",
          disabled: false,
        },
      ],
    };
  },

  methods: {
    cancelEdit() {
      this.edit = false;
      this.device = {enableTrigger: true}
    },
    getAsset(id) {
      this.edit = true;
      this.device = this.getDevices.filter((d) => d.id === id)[0];
      this.dAsset = this.device.asset ? this.device.asset.id : null;
    },
    updateAsset() {
      this.loading = true;
      AssetDataService.update(this.currentAsset.id, this.currentAsset)
        .then((response) => {
          console.log(response.data);
          this.retrieveAssets();
          this.message = "The asset was updated successfully!";
          this.loading = false;
          this.edit = false;
        })
        .catch((e) => {
          console.log(e);
          this.vError = true;
          this.loading = false;
          this.vMessage = e;
        });
    },
    async updateDevice() {
      this.loading = true;
      let cAsset = this.assets.filter((a) => a.id === this.dAsset);
      let payload = {
        asset: cAsset[0],
        enableTrigger: this.device.enableTrigger,
      };
      // try {
      //   await this.Apps.updateFlexOffer();
      // } catch (e) {
      //   this.vError = true;
      //   this.loading = false;
      //   this.vMessage = e.message;
      // }
      AssetDataService.addAssettoDevice(this.device.id, payload)
        .then((response) => {
          this.getAllDevices();
          this.message = "The asset was updated successfully!";
          this.loading = false;
          this.edit = false;
        })
        .catch((e) => {
          console.log(e);
          this.vError = true;
          this.loading = false;
          this.vMessage = e;
        });
    },
    retrieveCountries() {
      /* 
      CountryDataService.getAll()
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load countries sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load countries error: " + e);
        });
       */
      console.log(
        "HERE... currentUser's role: " + this.$store.state.auth.user.roles
      );
      console.log(
        "HERE... currentUser's country: " +
          this.$store.state.auth.user.countryCode
      );
      if (this.$store.state.auth.user.roles == "ROLE_ADMIN") {
        CountryDataService.getAll()
          .then((response) => {
            let countries = response.data;
            for (let c of countries) {
              this.countries.push(c.countryName);
            }
            console.log("HERE... load countries sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load countries error: " + e);
          });
      } else {
        CountryDataService.findByCountryCode(
          this.$store.state.auth.user.countryCode
        )
          .then((response) => {
            this.countries = response.data;
            console.log(
              "HERE... load country sucessfull: " + this.countries.countryCode
            );
          })
          .catch((e) => {
            console.log("HERE... load country error: " + e);
          });
      }
    },
    async saveAsset() {
      this.loading = true;
      var data = {
        companyCode: this.$store.state.auth.user.companyCode,
        assetCode: this.asset.assetCode,
        assetType: this.asset.assetType,
        assetName: this.asset.assetName,
        assetCapacity: this.asset.assetCapacity,
        assetAddress: this.asset.assetAddress,
        assetCity: this.asset.assetCity,
        assetPostCode: this.asset.assetPostCode,
        assetCountry: this.$store.state.auth.user.countryCode,
        assetLong: this.asset.assetLong,
        assetLat: this.asset.assetLat,
      };
      // try {
      //   await this.Apps.updateFlexOffer();
      // } catch (e) {
      //   this.vError = true;
      //   this.loading = false;
      //   this.vMessage = e.message;
      // }
      AssetDataService.create(data)
        .then((response) => {
          this.asset.id = response.data.id;
          console.log(response.data);
          this.retrieveAssets();
          this.submitted = true;
          this.loading = false;
          this.dialog = false;
        })
        .catch((e) => {
          console.log(e);
          this.vError = true;
          this.loading = false;
          this.vMessage = e;
        });
    },

    async saveDevice() {
      this.loading = true;
      let payload = {
        deviceName: this.device.deviceName,
        deviceId: this.device.deviceId,
        companyCode: this.$store.state.auth.user.companyCode,
        enableTrigger: this.device.enableTrigger,
      };
      // try {
      //   await this.Apps.updateFlexOffer();
      // } catch (e) {
      //   this.vError = true;
      //   this.loading = false;
      //   this.vMessage = e.message;
      // }
      AssetDataService.addDevice(payload)
        .then((response) => {
          console.log(response.data);
          this.getAllDevices();
          this.submitted = true;
          this.loading = false;
          this.dialog = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
          this.vError = true;
          this.vMessage = e;
        });
    },

    newAsset() {
      this.submitted = false;
      this.asset = {};
    },

    selectFile() {
      this.selectedFiles = this.$refs.file.files;
    },

    upload() {
      this.progress = 0;

      this.currentFile = this.selectedFiles.item(0);
      UploadService.upload(this.currentFile, (event) => {
        this.progress = Math.round((100 * event.loaded) / event.total);
      })
        .then((response) => {
          this.message = response.data.message;
          return UploadService.getFiles();
        })
        .then((files) => {
          this.fileInfos = files.data;
        })
        .catch(() => {
          this.progress = 0;
          this.message = "Could not upload the file!";
          this.currentFile = undefined;
        });

      this.selectedFiles = undefined;
    },
    changeCountry(e) {
      if (this.filterCountries.indexOf(e) === -1) {
        this.filterCountries.push(e);
      }
    },
    changePostal(e) {
      if (this.filterPostalCodes.indexOf(e) === -1) {
        this.filterPostalCodes.push(e);
      }
    },
    changeCity(e) {
      if (this.filterCities.indexOf(e) === -1) {
        this.filterCities.push(e);
      }
    },
    changeFilter() {
      this.filter = !this.filter;
    },
    closeCountry(e) {
      this.filterCountries.splice(this.filterCountries.indexOf(e), 1);
    },
    closePostal(e) {
      this.filterPostalCodes.splice(this.filterPostalCodes.indexOf(e), 1);
    },
    closeCity(e) {
      this.filterCities.splice(this.filterCities.indexOf(e), 1);
    },
    retrieveAssets() {
      console.log(
        "HERE... currentUser's role: " + this.$store.state.auth.user.roles
      );
      if (
        this.$store.state.auth.user.roles == "ROLE_ADMIN" &&
        this.$store.state.auth.user.countryCode == "BE"
      ) {
        AssetDataService.getAll()
          .then((response) => {
            this.assets = response.data;

            for (var i = 0; i < this.assets.length; i++) {
              if (this.cities.indexOf(this.assets[i].assetCity) == -1) {
                this.cities.push(this.assets[i].assetCity);
              }
              if (this.postcodes.indexOf(this.assets[i].assetPostCode) == -1) {
                this.postcodes.push(this.assets[i].assetPostCode);
              }
              // if (this.countries.indexOf(this.assets[i].assetCountry) == -1) {
              //   this.countries.push(this.assets[i].assetCountry);
              // }
              console.log("HERE... asset: ", this.assets[i]);
              //var btn = "<button class='table-button'>Edit</button>"
              var btn =
                '<a href="/asset/assets/' + this.assets[i]["id"] + '">Edit</a>';
              this.assets[i]["btn"] = btn;
            }
            // this.cities.sort();
            // this.postcodes.sort();
            // this.countries.sort();
            console.log("WHATHATHAHTHAHT", this.assets);
          })
          .catch((e) => {
            console.log("HERE... retrieve assets error: " + e);
          });
      } else {
        AssetDataService.findByCountryCode(
          this.$store.state.auth.user.countryCode
        )
          .then((response) => {
            this.assets = response.data;

            for (var i = 0; i < this.assets.length; i++) {
              if (this.cities.indexOf(this.assets[i].assetCity) == -1) {
                this.cities.push(this.assets[i].assetCity);
              }
              if (this.postcodes.indexOf(this.assets[i].assetPostCode) == -1) {
                this.postcodes.push(this.assets[i].assetPostCode);
              }
              // if (this.countries.indexOf(this.assets[i].assetCountry) == -1) {
              //   this.countries.push(this.assets[i].assetCountry);
              // }
              //var btn = "<button class='table-button'>Edit</button>"
              var btn =
                '<a href="/asset/assets/' + this.assets[i]["id"] + '">Edit</a>';
              this.assets[i]["btn"] = btn;
            }
            // this.cities.sort();
            // this.postcodes.sort();
            // this.countries.sort();
            console.log("YOOOOO", this.assets);
          })
          .catch((e) => {
            console.log("HERE... retrieve assets error: " + e);
          });
      }

      /* AssetDataService.getAll()
        .then((response) => {
          this.assets = response.data;
          console.log("HERE... retrieve assets sucessfull: " + response.data);

          for (var i = 0; i < this.assets.length; i++) {
            if (this.cities.indexOf(this.assets[i].assetCity) == -1) {
              this.cities.push(this.assets[i].assetCity)
            }
            if (this.postcodes.indexOf(this.assets[i].assetPostCode) == -1) {
              this.postcodes.push(this.assets[i].assetPostCode)
            }
            if (this.countries.indexOf(this.assets[i].assetCountry) == -1) {
              this.countries.push(this.assets[i].assetCountry)
            }
            console.log("HERE... asset: " + this.assets[i]["id"]);
            //var btn = "<button class='table-button'>Edit</button>"
            var btn = '<a href="/asset/assets/'+this.assets[i]["id"]+'">Edit</a>'
            this.assets[i]["btn"] = btn
            console.log("HERE... asset with action: " + btn)
          }
          this.cities.sort();
          this.postcodes.sort();
          this.countries.sort();
        })
        .catch((e) => {
          console.log("HERE... retrieve assets error: " + e);
        }); */
    },
    getAllDevices() {
      let code = this.$store.state.auth.user.companyCode;
      AssetDataService.getDevices(code)
        .then((response) => {
          this.devices = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    setLocations() {
      for (var i = 0; i < this.assets.length; i++) {
        this.locations.push(this.assets[i].assetCity);
      }
      console.log("HERE... list of locations: " + this.locations.toString());
    },

    getColumns() {
      this.columns = [
        {
          label: "Asset Type",
          field: "assetType",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Asset Name",
          field: "assetName",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Capacity (KWh)",
          field: "assetCapacity",
          type: "number",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Latitude",
          field: "assetLat",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Longitude",
          field: "assetLong",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Address",
          field: "assetAddress",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Address", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [],
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "City",
          field: "assetCity",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by City", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: this.cities,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Postcode",
          field: "assetPostCode",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Postcode", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: this.postcodes,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Country",
          field: "assetCountry",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by Country", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: this.countries,
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Action",
          thClass: "text-center",
          tdClass: "text-center",
          field: "btn",
          html: true,
          sortable: false,
        },
      ];
      return this.columns;
    },

    /* 
    retrieveLocations() {
      LocationDataService.getAll()
        .then((response) => {
          this.locations = response.data;
          console.log("HERE... retrieve locations sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... retrieve locations error: " + e);
        }); 
    },
    */

    refreshList() {
      this.retrieveAssets();
      this.currentAsset = null;
      this.currentIndex = -1;
    },

    setActiveAsset(asset, index) {
      this.currentAsset = asset;
      this.currentIndex = index;
    },

    deleteAsset(id) {
      AssetDataService.delete(id)
        .then((response) => {
          console.log(response.data);
          this.refreshList();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    removeAllAssets() {
      AssetDataService.deleteAll()
        .then((response) => {
          console.log(response.data);
          this.refreshList();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    searchCompanyCode() {
      AssetDataService.findByCompanyCode(this.companyCode)
        .then((response) => {
          this.assets = response.data;
          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    mappingAdress() {
      if (this.address) {
        this.asset.assetCity = this.$store.state.auth.user.city;
        this.asset.assetPostCode = this.$store.state.auth.user.postcode;
        this.asset.assetAddress =
          this.$store.state.auth.user.companyAddress +
          " " +
          this.$store.state.auth.user.buildingNumber;
      } else {
        this.asset.assetCity = "";
        this.asset.assetPostCode = "";
        this.asset.assetAddress = "";
      }
    },
  },

  updated() {
    // Fired every second, should always be true
    //this.retrieveAssets();
    //this.locations;
    //console.log("HERE... list of locations after updated: " + this.locations.toString());
  },

  computed: {
    getAssets() {
      return this.assets;
    },
    getDevices() {
      return this.devices;
    },
  },

  created() {},

  mounted() {
    this.$store.state.auth.user;
    this.retrieveCountries();
    this.retrieveAssets();
    this.getAllDevices();
    this.getColumns();
    UploadService.getFiles().then((response) => {
      this.fileInfos = response.data;
    });

    /* 
    this.$nextTick(function () {
      
    }); 
    */
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.asset-container {
  margin-top: -100px;
}

.offer-container {
  min-height: 100vh;
  background: #f8fcff;
}

.offer-inner-container {
  padding: 40px;
}

.offer-table-wrapper {
  box-shadow: 0 4px 6px 0 hsla(0, 0, 0, 0.2);
}

.top-offer-table-bar {
  background: #f9fafe;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f3fb;
}

.offer-search-wrapper {
  display: flex;
  align-items: center;
  width: 30%;
  max-width: 300px;
}

.offer-input {
  display: inline-block;
  font-size: 0.9rem;
  color: $black;
  line-height: 1.3;
  padding: 0.6em 0.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 10px 0 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.1em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.offer-input:focus,
.offer-search-button:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.offer-add-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #bfecb5;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  margin-right: 10px;
}

.offer-remove-button {
  font-size: 0.9rem;
  color: $black;
  padding: 6px 15px;
  background: #f8736b;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
}

.offer-table {
  background: #fff;
  width: 100%;
}

.offer-table th {
  color: #4a4a4a;
  font-size: 16px;
  //text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}

.offer-table tr:hover {
  background: #f5f8fd;
}

.table-button {
  background: none;
  border: none;
  padding: 0 5px;
  color: #007bff;
}

.table-button:hover {
  text-decoration: underline;
  color: #007bff;
}

.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.asset-filter-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 30px;
}

.chips-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 5px;
}

.chips-main {
  max-width: 200px;
  margin: 0 40px;
}

.divider2 {
  margin: 20px -140px 10px -140px;
  min-width: 800px;
}

.v-input--selection-controls {
  margin: 10px 0 20px 0 !important;
}

.offer-button-wrapper {
  display: flex;
}

.loading-wrapper {
  margin: 0 auto;
  padding: 15px 0;
  position: relative;
}

.loader-text {
  width: 100%;
  text-align: center;
  font-size: 18px;
  position: absolute;
  top: 0;
  left: 0;
}

.modal-button a {
  color: #ffffff;
  text-decoration: none;
}
</style>
